// Copyright (c) 2024. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import { useCookieConsent } from "../../../../../../io/hyperify/frontend/hooks/useCookieConsent";
import { CookieConsent } from "../../../../../../io/hyperify/frontend/types/CookieConsent";
import {
    COOKIE_CONSENT_VIEW_CLASS_NAME,
} from "../../../../core/constants/className";
import { CookieConsentArticle } from "../../common/cookieConsent/CookieConsentArticle";
import "./CookieConsentView.scss";

export interface CookieConsentViewProps {
    readonly t : TranslationFunction;
    readonly className ?: string;
    readonly enableSettingsButton ?: boolean;
}

export function CookieConsentView (props: CookieConsentViewProps) {
    const className = props?.className;
    const enableSettingsButton = props?.enableSettingsButton ?? false;
    const t = props?.t;
    const [cookieConsent] = useCookieConsent();
    if (cookieConsent !== CookieConsent.UNDEFINED) {
        return null;
    }
    return (
        <div className={
            COOKIE_CONSENT_VIEW_CLASS_NAME
            + (className? ` ${className}` : '')
        }>
            <CookieConsentArticle t={t} enableSettingsButton={enableSettingsButton} />
        </div>
    );
}
